import http from "./create_axios";

const CROP_TOKEN_KEY = "cropToken";

class User {
    getCropToken() {
        try {
            const fromSession = sessionStorage.getItem(CROP_TOKEN_KEY);
            if (fromSession) {
                return fromSession;
            }
        } catch (e) {
            /* ignore */
        }
        try {
            const fromLocal = localStorage.getItem(CROP_TOKEN_KEY);
            if (fromLocal) {
                try {
                    sessionStorage.setItem(CROP_TOKEN_KEY, fromLocal);
                } catch (e) {
                    /* ignore */
                }
                return fromLocal;
            }
        } catch (e) {
            /* ignore */
        }
        return "";
    }

    setCropToken(token) {
        try {
            if (token) {
                sessionStorage.setItem(CROP_TOKEN_KEY, token);
            } else {
                sessionStorage.removeItem(CROP_TOKEN_KEY);
            }
        } catch (e) {
            /* ignore */
        }
        try {
            if (token) {
                localStorage.setItem(CROP_TOKEN_KEY, token);
            } else {
                localStorage.removeItem(CROP_TOKEN_KEY);
            }
        } catch (e) {
            /* ignore */
        }
    }

    cropAuth(user, pass){
        return http.post("/api",{type:"crop_auth",user,pass});
    }
    getInfo(){
        return http.post("/api",{type:"get_information"});
    }
    createOrder(data){
        return http.post("/api",{type:"new_order",data:data});
    }
    createCroppingOrder(data){
        return http.post("/api",{type:"new_cropping_order",data:data}, {
            headers: {"x-crop-token": this.getCropToken()}
        });
    }
    getOrderStatus(orderId){
        return http.post("/api",{type:"order_status",orderId});
    }
    deleteTemp(photos){
        return http.post("/api",{type:"delete_temp",photos});
    }
    sendOrderPhoto(photo, orderId){
        return http.post("/api",{type:"send_photo",orderId,photo});
    }
    sendOrderPhotoFile(photo, orderId){
        const formData = new FormData();
        formData.append("orderId", orderId);
        formData.append("selectedSize", photo.selectedSize);
        formData.append("count", String(photo.count || 1));
        formData.append("photo", photo.photo);
        formData.append("file", photo.file, `${photo.photo}.jpg`);
        return http.post("/api/send_photo_file", formData, {
            timeout: 120000
        });
    }
}
export default new User();